const quiz = () => {
  const btnsPrevSlide = document.querySelectorAll(
      ".quiz__slide-switches__back"
    ),
    btnsNextSlide = document.querySelectorAll(".quiz__slide-btn"),
    slides = document.querySelectorAll(".quiz__slide"),
    forms = document.querySelectorAll(".quiz__slide-form");

  if (btnsPrevSlide.length < 1) {
    return;
  }  

  /* Переключение через кнопку "Назад" */
  (function PrevSlide() {
    for (let i = 0; i < btnsPrevSlide.length; i++) {
      btnsPrevSlide[i].addEventListener("click", () => {
        slides[i + 1].style.display = "none";
        slides[i].style.display = "flex";
      });
    }
  })();

  /* Переключение через кнопку "Далее" */
  (function nextSlide() {
    forms.forEach((form, i) => {
      let radios = form.querySelectorAll("input[type=radio]");

      if (radios.length > 0) {
        radios.forEach((radio) => {
          if (radio != document.querySelector("#PurposeTraining-6") && radio != document.querySelector("#FoundUs-5")) {
            radio.addEventListener("change", () => {
              btnsNextSlide[i + 1].disabled = false;
  
              setTimeout(() => {
                slides[i + 1].style.display = "none";
                slides[i + 2].style.display = "flex";
              }, 500);
            });
          } else {
            radio.addEventListener("change", () => {
              btnsNextSlide[i + 1].disabled = false;
            });
          }
        });
      }
    });

    for (let i = 0; i < btnsNextSlide.length; i++) {
      btnsNextSlide[i].addEventListener("click", () => {
        if (i == btnsNextSlide.length - 1) return;
        slides[i].style.display = "none";
        slides[i + 1].style.display = "flex";
      });
    }
  })();
};

export default quiz;
